import * as RadixScrollArea from '@radix-ui/react-scroll-area'
import {Viewport} from '@radix-ui/react-scroll-area'
import styled, {css, CSSProperties} from 'styled-components'

export const StyledRoot = styled(RadixScrollArea.Root)<{$overflowX?: CSSProperties['overflowX']}>(
    ({$overflowX}) => css`
        overflow-x: ${$overflowX};
    `
)

export const StyledViewport = styled(Viewport)`
    height: 100%;
    max-height: inherit;
    /* This was added to enable text overflow, which seems to be prevented by using display: table */
    & > div {
        display: block !important;
    }
`
